import Phaser from "phaser";
import Pqp from "../../3x1010/Pqp";
import ProgressBar from "./ProgressBar";

export default class TagVelocity extends Phaser.GameObjects.Container {
  constructor(scene, value, label, callback) {
    super(scene);
    this.value = value;
    this.scene = scene;
    this.label = label;
    this.callback = callback;
  }

  init() {
    this.createText();
    this.createActive();
    this.setInteractive({ hitArea: new Phaser.Geom.Rectangle(0, 0, this.w, this.h), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true });

    /*const test = this.scene.add.rectangle(0, 0, this.w, this.h, 0);
    test.setOrigin(0, 0);
    this.add(test);*/
    this.on("pointerup", this.onClick.bind(this));
  }

  onClick() {
    this.dispatch(TagVelocity.EVENT_CLICKED, this.value);
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      //if (!Pqp.isNullOrEmpty(data)) {
      e.data = data;
      //}
      this.callback.call(null, e);
    }
  }

  createText() {
    const txt = this.scene.add.text(0, 0, this.label, { fontFamily: "DIN Next LT Pro", fontSize: "24px", color: this.toHexColor(ProgressBar.COLOR_2) });
    this.add(txt);
    this.w = txt.width;
    this.h = txt.height;
    this.txt = txt;
  }

  createActive() {
    const line = this.scene.add.rectangle(0, 0, this.w, 2, ProgressBar.COLOR_BACK);
    line.setOrigin(0, 0);
    this.add(line);
    this.line = line;
    this.line.visible = false;
    line.y = this.txt.height;
  }

  setActive(lFlag) {
    this.line.visible = lFlag;
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }
}

TagVelocity.EVENT_CLICKED = "eventClicked";
